export function getDocumentName(
    documentName: string,
    maxSize: number,
    lastCharactersCount: number = 7,
    delimiter: string = '...',
): string {
    return documentName.length > maxSize
        ? `${documentName.slice(0, maxSize - (lastCharactersCount + delimiter.length))}${delimiter}${documentName.slice(
              -lastCharactersCount,
          )}`
        : documentName;
}
